// removed by extract-text-webpack-plugin
module.exports = {"box":"_1FwmKPbPcMonfYIfEdf5v","iconBtn":"_2pcJdirTQIL4yFvA4B9Efw","list":"e1ksanTepmrV3XwpJ1tjs"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateGym/ExperiencesList/style.module.css
// module id = 497
// module chunks = 37